// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1g5_A","colMaxWidth":"Table_colMaxWidth__3-zMh"};